import Vue from 'vue';
export const EventBus = new Vue();


// WEBPACK FOOTER //
// ./resources/assets/js/event-bus.js